import { cn } from '@/lib/utils'

export const ENGINES = ['google', 'bing'] as const
export type Engine = (typeof ENGINES)[number]

export const ENGINE_LABELS: Record<Engine, string> = { google: 'Google', bing: 'Bing' }

/** The stroke/fill class for an engine's series, so every chart agrees on hue. */
export const ENGINE_STROKE: Record<Engine, string> = {
  google: 'stroke-engine-google',
  bing: 'stroke-engine-bing',
}
export const ENGINE_BG: Record<Engine, string> = {
  google: 'bg-engine-google',
  bing: 'bg-engine-bing',
}

/**
 * Each engine's own mark, in its own colours. The series colour says which
 * line is which at a glance; the mark is what makes the answer certain.
 */
export function EngineMark({ engine, className }: { engine: Engine; className?: string }) {
  return engine === 'google' ? (
    <svg viewBox="0 0 18 18" className={cn('size-3 shrink-0', className)} role="img">
      <title>Google</title>
      <path
        fill="#EA4335"
        d="M9 3.48c1.69 0 2.83.73 3.48 1.34l2.54-2.48C13.46.89 11.43 0 9 0 5.48 0 2.44 2.02.96 4.96l2.91 2.26C4.6 5.05 6.62 3.48 9 3.48z"
      />
      <path
        fill="#4285F4"
        d="M17.64 9.2c0-.74-.06-1.28-.19-1.84H9v3.34h4.96c-.1.83-.64 2.08-1.84 2.92l2.84 2.2c1.7-1.57 2.68-3.88 2.68-6.62z"
      />
      <path
        fill="#FBBC05"
        d="M3.88 10.78A5.54 5.54 0 0 1 3.58 9c0-.62.11-1.22.29-1.78L.96 4.96A9.008 9.008 0 0 0 0 9c0 1.45.35 2.82.96 4.04l2.92-2.26z"
      />
      <path
        fill="#34A853"
        d="M9 18c2.43 0 4.47-.8 5.96-2.18l-2.84-2.2c-.76.53-1.78.9-3.12.9-2.38 0-4.4-1.57-5.12-3.74L.97 13.04C2.45 15.98 5.48 18 9 18z"
      />
    </svg>
  ) : (
    <svg viewBox="0 0 24 24" className={cn('size-3 shrink-0', className)} role="img">
      <title>Bing</title>
      <path
        fill="#008373"
        d="M3.605 0l4.8 1.69v16.88l6.76-3.9-3.315-1.555-2.09-5.2 10.64 3.738v5.435L8.41 24l-4.805-2.675V0z"
      />
    </svg>
  )
}
